(ns teamoesterreich.admin-mode.event.detail.event-stepper
  (:require [clojure.string]
            [goog.string.format]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [goog.json :as json]
            [clojure.string :as str]
            [teamoesterreich.util.log :as log]

            [teamoesterreich.view-state :as store]
            [teamoesterreich.admin-mode.actions :as a]
            [teamoesterreich.admin-mode.data.event :as d-events]
            [teamoesterreich.admin-mode.data.rights :as d-rights]

            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [teamoesterreich.admin-mode.modal.message :as message-modal]
            [teamoesterreich.admin-mode.component.ws-event-sync-component :as ws-event-sync-component]


            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent-material-ui.icons.keyboard-arrow-right :refer [keyboard-arrow-right]]
            [reagent-material-ui.icons.check :refer [check]]
            [reagent-material-ui.icons.delete-outline :refer [delete-outline]]
            [reagent-material-ui.icons.location-searching :refer [location-searching]]
            [reagent-material-ui.icons.warning :refer [warning]]
            [reagent-material-ui.icons.info :refer [info]]
            ))




(defonce BUTTON_GRID {:item true :xl 2 :md 3 :xs 6})
(defn get-it []
  (let [!st (r/atom {:tab 0})]
    (fn []
      (let [!tab (r/cursor !st [:tab])
            !ws-update-lock (r/cursor store/app-state [:ws-update-lock])
            !event (r/cursor store/app-state [:selected-event])
            !show-delete? (r/cursor store/app-state [:event-delete])
            !event-detail-loaded? (r/cursor store/app-state [:event-detail-loaded])
            !show-start-warn? (r/cursor store/app-state [:show-start-warn])
            !show-end-warn? (r/cursor store/app-state [:show-end-warn])
            !show-end-not-possible? (r/cursor store/app-state [:show-end-not-possible])
            event-timeFrom (str (:crowdtaskerEvent-timeFrom @!event))
            event-status (or (:crowdtaskerEvent-status @!event) "created")
            event-step (case event-status
                         "created" 0
                         "waitAccept" 1
                         "collecting" 2
                         "running" 3
                         "finished" 4
                         "closed" 4
                         0)
            ro? (> event-step 3)
            ok? (and (> event-step 1) (< event-step 4))
            table-set-base {:ro? ro?}
            cnt-responseStatus-fn (fn [status] (count (filter (fn [e] (and (= "undefined" (or (:crowdtaskerEventMember-missionState e) "undefined"))
                                                                           (= status (or (:crowdtaskerEventMember-responseState e)
                                                                                         (if (:crowdtaskerEventMember-alarmedType e) "alarmed" "undefined"))))) (:crowdtaskerEvent-member @!event))))
            cnt-missionStatus-fn (fn [status] (count (filter (fn [e] (= status (or (:crowdtaskerEventMember-missionState e) "undefined"))) (:crowdtaskerEvent-member @!event))))
            ]








        [mui/card {}
         [:h3 "Einsatz `" (:crowdtaskerEvent-name @!event) "`"
          [ws-event-sync-component/ws-event-reload !event-detail-loaded? :crowdtasker-event (:crowdtaskerEvent-uuid @!event) !ws-update-lock]
          ]
         [mui/stepper {:active-step event-step}
          [mui/step {
                     :key "Step1"
                     }
           [mui/step-label "Erstellen"]]

          [mui/step {
                     :key "Step2"
                     }
           [mui/step-label "Wartet auf Freischalten"]]

          [mui/step {
                     :key "Step3"
                     }
           [mui/step-label "Sammelt Rückmeldungen"]]

          [mui/step {
                     :key "Step4"
                     }
           [mui/step-label "Läuft gerade"]]

          [mui/step {
                     :key "Step5"
                     }
           [mui/step-label "Abgeschlossen"]]
          ]

         [are-you-sure-modal/are-you-sure-modal !show-delete? "Nur für Superuser! Einsatz wirklich löschen ?" "löschen"
          (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-active false}
                                       (fn [data] (swap! store/app-state assoc
                                                         :selected-event nil
                                                         :event-detail-loaded false
                                                         :event nil
                                                         :site :event-list
                                                         ))))]

         [are-you-sure-modal/are-you-sure-modal !show-start-warn? "Nur für Superuser! Es ist noch nicht Einsatzbeginn! Willst du ihn trotzdem starten ?" "Trotzdem starten"
          (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-status "running"} (fn [data] (reset! !event-detail-loaded? false))))]

         [are-you-sure-modal/are-you-sure-modal !show-end-warn? "Willst du diesen Einsatz beenden ?" "beenden"
          (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event)
                                       {:crowdtaskerEvent-status "finished"
                                        :crowdtaskerEvent-timeTo (or (:crowdtaskerEvent-timeTo @!event)
                                                                     (let [date (js/Date.)]
                                                                       (goog.string.format "%04d%02d%02dT%02d%02d%02d.000Z" (.getFullYear date) (inc (.getMonth date)) (.getDate date) (.getHours date) (.getMinutes date) (.getSeconds date)) ;20180701T100000.000Z
                                                                       ))
                                        } (fn [data] (reset! !event-detail-loaded? false))))]

         [message-modal/modal !show-end-not-possible? (r/as-element [:p [warning] [:br] "Dieser Einsatz ist nicht abschließbar! " [:br] "Prüfe ob alle Teilnehmer auf `Reserve` oder `Im Einsatz` sind"])]
         [mui/grid {:container  true
                    :direction  "row"
                    :justify    "flex-start"
                    :alignItems "flex-start"
                    :spacing    1}
          [mui/grid BUTTON_GRID [mui/button {:startIcon (r/as-element [keyboard-arrow-left]) :variant "outlined"
                                             :onClick   #(a/set-page :event-list)}
                                 "Zurück"]]


          (when (= event-status "created")
            [mui/grid BUTTON_GRID [mui/button {:variant   "outlined" :color "secondary"
                                               :disabled  (not (and
                                                                 ; not needed Franz 20220627  (> (:_crowdtaskerEvent-countMembers @!event) 0)
                                                                 (> (count (str (:crowdtaskerEvent-timeFrom @!event))) 0)
                                                                 (> (count (str (:crowdtaskerEvent-name @!event))) 0)
                                                                 (> (count (str (:crowdtaskerEvent-acceptableUntil @!event))) 0)
                                                                 ))
                                               :startIcon (r/as-element [check])
                                               :onClick   (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-status "waitAccept"} (fn [data] (reset! !event-detail-loaded? false))))
                                               }
                                   "Freischalten beantragen"]])


          (when (and (= event-status "waitAccept") (d-rights/allow-admin-for d-rights/CLASSIC_ACTIVATE))
            [mui/grid BUTTON_GRID [mui/button {:variant   "outlined" :color "primary"
                                               :startIcon (r/as-element [keyboard-arrow-left])
                                               :onClick   (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-status "created"} (fn [data] (reset! !event-detail-loaded? false))))}
                                   "Ablehnen"]])

          (when (and (= event-status "waitAccept") (d-rights/allow-admin-for d-rights/CLASSIC_ACTIVATE))
            [mui/grid BUTTON_GRID [mui/button {:variant   "outlined" :color "secondary"
                                               :startIcon (r/as-element [keyboard-arrow-right])
                                               :onClick   (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-status "collecting" :crowdtaskerEvent-published true} (fn [data] (reset! !event-detail-loaded? false))))}
                                   "Freischalten"]])

          (when (and (= event-status "waitAccept") (not (d-rights/allow-admin-for d-rights/CLASSIC_ACTIVATE)))
            [mui/grid BUTTON_GRID [mui/chip {:label "Wartet auf die Freigabe!" :color "#e10032" :icon (r/as-element [info])}]])


          (when (= event-status "collecting")
            [mui/grid BUTTON_GRID [mui/button {:variant "outlined" :color "secondary"
                                               :onClick (fn [] (d-events/>event-send-alarm (:crowdtaskerEvent-uuid @!event)))
                                               :title   "Sendet SMS/Push an alle die noch keines bekommen haben"}
                                   "Manuell zugeteilt -> Anfragen"]])


          (when (and (= event-status "collecting"))
            [mui/grid BUTTON_GRID [mui/button {:variant  "outlined"
                                               :disabled (< (.getTime (new js/Date)) (js/Date.parse (str (subs event-timeFrom 6 8) "." (subs event-timeFrom 4 6) "." (subs event-timeFrom 0 4))))
                                               :color    "secondary"
                                               :onClick  (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-status "running"} (fn [data] (reset! !event-detail-loaded? false))))}
                                   "Einsatz starten"]])

          (when (= event-status "running")
            [mui/grid BUTTON_GRID [mui/button {:variant  "outlined"

                                               :disabled (> (cnt-responseStatus-fn "accepted") 0)
                                               :onClick  (fn [] (if (and (= event-status "running") (> (cnt-responseStatus-fn "accepted") 0))
                                                                  (reset! !show-end-not-possible? true)
                                                                  (reset! !show-end-warn? true)
                                                                  ))
                                               :color    "secondary"}
                                   "Einsatz abschließen"]])

          (when (= event-status "created")
            [mui/grid BUTTON_GRID [mui/button {:variant   "outlined" :color "primary"
                                               :startIcon (r/as-element [delete-outline])
                                               :onClick   #(reset! !show-delete? true)}
                                   "Löschen"]])

          (when (and (= event-status "collecting") (d-rights/allow-admin-for d-rights/CLASSIC_ACTIVATE))
            [mui/grid BUTTON_GRID [mui/button {:variant   "outlined"
                                               :onClick   (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-status "created" :crowdtaskerEvent-published false} (fn [data] (reset! !event-detail-loaded? false))))
                                               :startIcon (r/as-element [keyboard-arrow-left])
                                               :style     {:color "orange"}}
                                   "Freischaltung zurücknehmen"]])

          (when (and (= event-status "collecting") (d-rights/is-superuser?))
            [mui/grid BUTTON_GRID [mui/button {:variant   "outlined"
                                               :onClick   #(reset! !show-start-warn? true)

                                               :startIcon (r/as-element [keyboard-arrow-right])
                                               :style     {:color "orange"}}
                                   "Einsatz starten"]])

          (when (and (= event-status "running") (d-rights/is-superuser?))
            [mui/grid BUTTON_GRID [mui/button {:variant   "outlined"
                                               :onClick   (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-status "collecting"} (fn [data] (reset! !event-detail-loaded? false))))

                                               :startIcon (r/as-element [keyboard-arrow-left])
                                               :style     {:color "orange"}}
                                   "starten zurücknehmen"]])

          (when (and (= event-status "finished") (d-rights/is-superuser?))
            mui/grid [BUTTON_GRID [mui/button {:variant   "outlined"
                                               :onClick   (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-status "running"} (fn [data] (reset! !event-detail-loaded? false))))

                                               :startIcon (r/as-element [keyboard-arrow-left])
                                               :style     {:color "orange"}}
                                   "beenden zurücknehmen"]])


          (when (and (= event-status "created") (d-rights/is-superuser?))
            [mui/grid BUTTON_GRID [mui/button {:variant   "outlined" :color "secondary"
                                               :title     "Nur Superuser, versendet kein Mail/SMS"
                                               :startIcon (r/as-element [keyboard-arrow-right])
                                               :onClick   (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-status "collecting" :crowdtaskerEvent-published true} (fn [data] (reset! !event-detail-loaded? false))))
                                               :style     {:color "orange"}}
                                   "Direkt Freischalten (superuser)"]])


          [mui/grid {:item true :xs 12}
           [:span {:style {:color "red"}}
            [:br]
            [:br]
            (str
              (when (< (:_crowdtaskerEvent-countMembers @!event) 1) "Keine Personen eingeladen, ")
              (when (< (count (str (:crowdtaskerEvent-timeFrom @!event))) 5) "Beginn Datum fehlt, ")
              (when (< (count (str (:crowdtaskerEvent-name @!event))) 1) "Name fehlt, ")
              (when (< (count (str (:crowdtaskerEvent-description @!event))) 1) "Einsatzanfragen fehlen, ")
              (when (< (count (str (:crowdtaskerEvent-acceptableUntil @!event))) 5) "Anmelde Ende fehlt, ")


              (when (and (= event-status "running") (> (cnt-responseStatus-fn "accepted") 0))
                (str (cnt-responseStatus-fn "accepted") " Zusagen noch nicht zugeteilt (Reserve/Im Einsatz)")))]
           [:br]
           [:br]
           ]
          ]]
        ))))
















